var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * One assembled tile: which catalogue tile is laid into which slot, and how it
 * is oriented (which face up, and the rotation 0..N-1 for the shape). The
 * server rolls these at setup; clients reproduce the exact board from them.
 */
export class TilePlacement extends Schema {
    constructor() {
        super(...arguments);
        /** Slot id, e.g. "summit-0". */
        this.slot = "";
        /** Catalogue tile id, e.g. "summit-2". */
        this.tileId = "";
        /** Which face is up: "A" or "B". */
        this.face = "A";
        /** Rotation step (0..rotationCount-1 for the shape). */
        this.rotation = 0;
    }
}
__decorate([
    type("string")
], TilePlacement.prototype, "slot", void 0);
__decorate([
    type("string")
], TilePlacement.prototype, "tileId", void 0);
__decorate([
    type("string")
], TilePlacement.prototype, "face", void 0);
__decorate([
    type("uint8")
], TilePlacement.prototype, "rotation", void 0);
//# sourceMappingURL=TilePlacement.js.map